import { FaStar } from "react-icons/fa";
import styles from "./AwardPage.module.css";
import { MdOutlineAppRegistration } from "react-icons/md";



const RegistrationPage = () => {
    return (
        <div>
            <main className={styles.mainContent}>
                <div className={styles.comingSoonCard}>
                    <div className={styles.iconContainer}>
                        <MdOutlineAppRegistration className={styles.trophyIcon} />

                        <FaStar className={`${styles.starIcon} ${styles.starOne}`} />
                        <FaStar className={`${styles.starIcon} ${styles.starTwo}`} />
                        <FaStar className={`${styles.starIcon} ${styles.starThree}`} />
                    </div>

                    <h1 className={styles.title}>
                        Registration
                    </h1>

                    <p className={styles.subtitle}>
                        Registration details will be
                        launching soon. Stay tuned!
                    </p>

                    <div className={styles.badge}>
                        Coming Soon 2026
                    </div>
                </div>

            </main>
        </div>
    )
};

export default RegistrationPage;